/**
 * Bulk-quantity discount tiers — applies automatically on the cart.
 *   Buy 2  →  10 % off
 *   Buy 3  →  15 % off
 *   Buy 5  →  20 % off
 */
export const DISCOUNT_TIERS = [
  { min: 5, percent: 20 },
  { min: 3, percent: 15 },
  { min: 2, percent: 10 },
];

/** Total piece count across cart (sum of quantities). */
const totalQty = (items) =>
  (items || []).reduce((n, it) => n + (it.quantity || 0), 0);

/** Pick the highest tier the cart qualifies for. */
export const activeTier = (items) => {
  const qty = totalQty(items);
  return DISCOUNT_TIERS.find((t) => qty >= t.min) || null;
};

/** Items count needed to unlock the next tier (for nudges). */
export const nextTier = (items) => {
  const qty = totalQty(items);
  // First (largest) tier whose min > current qty
  const ascending = [...DISCOUNT_TIERS].sort((a, b) => a.min - b.min);
  return ascending.find((t) => t.min > qty) || null;
};

/** Compute the discounted totals for a list of cart items. */
export const computeTotals = (items) => {
  const subtotal = (items || []).reduce(
    (s, it) => s + Number(it.price || 0) * (it.quantity || 0),
    0,
  );
  const tier = activeTier(items);
  const discountPercent = tier ? tier.percent : 0;
  const discountAmount = subtotal * (discountPercent / 100);
  const total = subtotal - discountAmount;
  return {
    subtotal,
    discountPercent,
    discountAmount,
    total,
    tier,
    next: nextTier(items),
    qty: totalQty(items),
  };
};
